/**
 *
 * @type {import('@webreact/webreactor/dist/Router/types').ComponentInit[]}
 */
const components = [
    {
        file: (async () => (await (import('./components/educations-archive'))).default),
        target: '.post-type-archive-education'
    },
    {
        file: (async () => (await (import('./components/courses-archive'))).default),
        target: '.post-type-archive-course'
    },
    {
        file: (async () => (await (import('./components/stories-archive'))).default),
        target: '.post-type-archive-story'
    },
    {
        file: (async () => (await (import('./components/posts-archive'))).default),
        target: '.blog'
    },
    {
        file: (async () => (await (import('./components/projects-archive'))).default),
        target: '.post-type-archive-project'
    },
    {
        file: (async () => (await (import('./components/downloads-archive'))).default),
        target: '.post-type-archive-download'
    },
    {
        file: (async () => (await (import('./components/events-archive'))).default),
        target: '.post-type-archive-event'
    },
    {
        file: (async () => (await (import('./components/archive-filter-bar'))).default),
        target: '[data-component="archive-filter-bar"]'
    },
    {
        file: (async () => (await (import('./components/locations-google-maps'))).default),
        target: '.js-locations-google-maps'
    },
    {
        file: (async () => (await (import('./components/education-google-maps'))).default),
        target: '#single-education-location-map'
    },
    {
        file: (async () => (await (import('./components/gravity-forms'))).default),
        target: '.gform_wrapper'
    },
    {
        file: (async () => (await (import('./components/accordion'))).default),
        target: '.accordion'
    },
    {
        file: (async () => (await (import('./components/gallery-slider'))).default),
        target: '.gallery-slider'
    },
    {
        file: (async () => (await (import('./components/in-my-area'))).default),
        target: '.page-template-template-in-my-area'
    },
    {
        file: (async () => (await (import('./components/sidebar'))).default),
        target: '.sidebar'
    },
    {
        file: (async () => (await (import('./components/scroll'))).default),
        target: 'a[href*="#"]'
    },
    {
        file: (async () => (await (import('./components/global'))).default),
        target: 'body'
    },
]

export {
    components
}